import CompaniesActionMenu from "./companiesActionsMenu";

function getLabs(company) {
  if (!("laboratories" in company)) {
    return "";
  }
  return company.laboratories
    .map((lab) => {
      if ("code" in lab && "name" in lab && "id" in lab) {
        return lab.code + "-" + lab.name;
      }
      return [];
    })
    .join();
}

function getTableData(companiesList, setIsEditingCompany, setCompanyToEdit) {
  //   companiesList: [
  //   {
  //     "id": 1,
  //     "code": "AEN",
  //     "name": "AENSA",
  //     "representative": "Francisco Troya",
  //     "telephone": "026009999",
  //     "laboratories": [
  //         {
  //           "id": 174327,
  //           "code": "A1",
  //           "name": "LAB TEST TEMPORAL"
  //         }
  //     ]
  // }
  // ]
  let _rows = [];
  companiesList.forEach((element, index) => {
    const row = {
      Nro: index + 1,
      Codigo: element.code,
      Nombre: element.name,
      Representante: element.representative,
      Telefono: element.telephone,
      Laboratorios: getLabs(element),
      Acciones: (
        <CompaniesActionMenu
          setIsEditingCompany={setIsEditingCompany}
          element={element}
          setElementToEdit={setCompanyToEdit}
        ></CompaniesActionMenu>
      ),
    };
    _rows.push(row);
  });

  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "10%" },
      { Header: "Codigo", accessor: "Codigo" },
      { Header: "Nombre", accessor: "Nombre" },
      { Header: "Representante", accessor: "Representante" },
      { Header: "Telefono", accessor: "Telefono" },
      { Header: "Laboratorios", accessor: "Laboratorios" },
      { Header: "Acciones", accessor: "Acciones", width: "10%" },
    ],
    rows: _rows,
  };
}

export default getTableData;
